import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { ApolloLink } from '@apollo/client';
import config from '@src/config/config';
import { getToken } from '../utils/getToken';
import { createAuthHeader } from '../utils/createAuthHeader';
import { isTokenExpired } from '../utils/isTokenExpired';
import { handleTokenRefresh } from '../utils/handleTokenRefresh';

const checkAndUpdateToken = () => {
  return new Promise<string | undefined>(resolve => {
    const accessToken = getToken();

    if (accessToken && isTokenExpired(accessToken)) {
      handleTokenRefresh(newAccessToken => {
        resolve(newAccessToken);
      });

      return;
    }

    resolve(accessToken);
  });
};

const wsClient = createClient({
  connectionParams: async () => {
    const accessToken = await checkAndUpdateToken();

    return {
      authorization: accessToken ? createAuthHeader(accessToken) : null,
    };
  },
  retryAttempts: 100,
  shouldRetry: () => true,
  url: config.graphqlSocketUri,
});

export const graphQLWsLink: ApolloLink = new GraphQLWsLink(wsClient);
